import React from "react";
import Logo from "../../Logo/Logo";

export default function NavigationBarLogo() {
  return <Logo />;
}
